// libraries.
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "@store";

// interfaces.
import { PredictionPublicationPrice } from "../interfaces/interfaces";

export interface VIMMetrics {
  clicks_15_dias_antes: number | null;
  precio_actual_de_publicacion: number | null;
  precio_recomendado: number | null;
  visitas_15_dias_antes: number | null;
  visitas_para_promesa: number | null;
}

export interface VIMState extends VIMMetrics {
  hasVIM: boolean;
  selectedOption: PredictionPublicationPrice | null;
  suggestionOption: PredictionPublicationPrice | null;
  wasOpened: boolean;
}

export const initialState: VIMState = {
  clicks_15_dias_antes: 0,
  hasVIM: false,
  precio_actual_de_publicacion: 0,
  precio_recomendado: 0,
  selectedOption: null,
  suggestionOption: null,
  visitas_15_dias_antes: 0,
  visitas_para_promesa: 0,
  wasOpened: false,
};

// slice.
export const domainVIMSlice = createSlice({
  initialState,
  name: "domainVIM",
  reducers: {
    resetVIMMetrics: (state) => {
      state.clicks_15_dias_antes = null;
      state.precio_actual_de_publicacion = null;
      state.precio_recomendado = null;
      state.visitas_15_dias_antes = null;
      state.visitas_para_promesa = null;
    },
    setHasVIM: (state, action: PayloadAction<boolean>) => {
      state.hasVIM = action.payload;
    },
    setWasOpened: (state, action: PayloadAction<boolean>) => {
      state.wasOpened = action.payload;
    },
    setSelectedOption: (
      state,
      action: PayloadAction<PredictionPublicationPrice | null>,
    ) => {
      state.selectedOption = action.payload;
    },
    setSuggestionOption: (
      state,
      action: PayloadAction<PredictionPublicationPrice | null>,
    ) => {
      state.suggestionOption = action.payload;
    },
    setVIMMetrics: (state, action: PayloadAction<VIMMetrics>) => {
      Object.assign(state, action.payload);
    },
    setDefaultState: () => {
      return initialState;
    },
  },
});

export const {
  resetVIMMetrics,
  setDefaultState,
  setHasVIM,
  setWasOpened,
  setSelectedOption,
  setSuggestionOption,
  setVIMMetrics,
} = domainVIMSlice.actions;

export default domainVIMSlice.reducer;

// selectors.
export const getWasOpened = (state: RootState) => state.domainVIM.wasOpened;

export const getSelectedOption = (state: RootState) =>
  state.domainVIM.selectedOption;

export const getSuggestionOption = (state: RootState) =>
  state.domainVIM.suggestionOption;

export const getVIMMetrics = (state: RootState): VIMMetrics => ({
  clicks_15_dias_antes: state.domainVIM.clicks_15_dias_antes,
  precio_actual_de_publicacion: state.domainVIM.precio_actual_de_publicacion,
  precio_recomendado: state.domainVIM.precio_recomendado,
  visitas_15_dias_antes: state.domainVIM.visitas_15_dias_antes,
  visitas_para_promesa: state.domainVIM.visitas_para_promesa,
});

export const getHasVIM = (state: RootState) => state.domainVIM.hasVIM;
